export function isNumber(v) {
  return typeof v === "number" && !isNaN(v);
}
